import React, { useEffect, useState } from "react";
import PromoBanner from "../Components/PromoBanner";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";

const TermsCondition = () => {
  const [termsContent, setTermsContent] = useState(""); // State to hold fetched content
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  // Fetch Terms & Conditions content from the API
  const fetchTermsContent = async () => {
    setIsLoading(true);

    try {
      const response = await fetch(
        "https://backend.printtrio.co.uk/api/pages/get-terms"
      );

      if (!response.ok) {
        throw new Error("Failed to fetch terms and conditions.");
      }

      const data = await response.json();

      // Check if the API response is successful and contains content
      if (data.success && data.data && data.data.length > 0) {
        setTermsContent(data.data[0].content); // Set the HTML content
      } else {
        setError("No terms and conditions content found.");
      }
    } catch (err) {
      console.error("Error fetching terms and conditions:", err);
      setError("An error occurred while fetching the terms and conditions.");
    } finally {
      setIsLoading(false);
    }
  };

  // Fetch content when the component mounts
  useEffect(() => {
    fetchTermsContent();
  }, []);

  return (
    <div>
      <PromoBanner />
      <Navbar />
      {isLoading ? (
        <div className="flex justify-center items-center h-screen">
          {/* Tailwind simple spinner */}
          <svg
            className="animate-spin h-12 w-12 text-pink-500"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            />
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8v8H4z"
            />
          </svg>
        </div>
      ) : (
        <>
      <div className="px-8 py-12 font-sans text-gray-800 max-w-screen-2xl mx-auto relative">
        <h1 className="text-3xl font-bold mb-6">Terms & Conditions</h1>
        <p className="mb-4">Please read our terms and conditions carefully.</p>

        {error ? (
          <p className="text-red-500">{error}</p>
        ) : (
          <div
            className="space-y-6 text-sm text-gray-700"
            dangerouslySetInnerHTML={{ __html: termsContent }} 
          />
        )}
      </div>
      <Footer />
      </>
      )}
    </div>
  );
};

export default TermsCondition;
